module.exports = __webpack_public_path__ + "static/media/approve.268f65a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/approve.png
// module id = 219
// module chunks = 0